export interface Brand {
  name: string;
  shortName: string;
  primaryColor: string;
  logoText: string;
  logoAccent: string;
  website: string;
}

// Single canonical brand — traffic-bot.com now 301-redirects server-side.
const BRAND: Brand = {
  name: 'Traffic Creator',
  shortName: 'Traffic Creator',
  primaryColor: '#ff4d00',
  logoText: 'TRAFFIC',
  logoAccent: 'CREATOR',
  website: 'https://traffic-creator.com'
};

export const getBrand = (): Brand => BRAND;

/** @deprecated traffic-bot.com now 301-redirects; always returns false */
export const isTrafficBot = (): boolean => false;

/** @deprecated Always true now that traffic-bot.com redirects */
export const isTrafficCreator = (): boolean => true;

export const BRAND_COLORS = {
  primary: '#ff4d00',
  primaryHover: '#ff6b35',
  background: '#ffffff',
  backgroundSecondary: '#f9fafb',
  text: '#111827',
  textSecondary: '#6b7280',
  border: '#e5e7eb'
};
